import { render, staticRenderFns } from "./SpaceManagerFile.vue?vue&type=template&id=54abeec0&scoped=true"
import script from "./SpaceManagerFile.vue?vue&type=script&lang=js"
export * from "./SpaceManagerFile.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagerFile.vue?vue&type=style&index=0&id=54abeec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abeec0",
  null
  
)

export default component.exports